import React from "react";
import { Link } from "react-router-dom";
import DemanderMesIdentifiantsForm from "./DemanderMesIdentifiantsForm";
import "../assets_/_login.css";

const DemanderIdentifiants = () => {
  return (
    <div>
      <div className="login-form demander-identifiant">
        <main className="d-flex align-items-center min-vh-100 py-3 py-md-0">
          <div className="container">
            <div className="card login-card">
              <div className="row no-gutters">
                <div className="col-md-5  d-xs-none d-md-flex d-lg-flex d-sm-none">
                  <img
                    src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/78c4af118001599.608076cf95739.jpg"
                    alt="login"
                    className="login-card-img"
                  />
                </div>
                <div className="col-md-7">
                  <div className="card-body">
                    <Link to="/" className="brand-wrapper">
                      <img
                        src="assets/img/hna-meak/Hna_m3ak_logo2.png"
                        alt="logo"
                        className="logo"
                      />
                    </Link>
                    <p className="login-card-description mt-3">Demander Mes identifiants</p>
                    
                    <DemanderMesIdentifiantsForm></DemanderMesIdentifiantsForm>

                    <a href="!#" className="forgot-password-link">
                      Mot de passe oublié?
                    </a>
                    <p className="login-card-footer-text">
                      Vous avez déjà un compte ?
                      <Link to="/login" className="ms-1 text-decoration-underline">
                        Se connecter
                      </Link>
                    </p>
                    <nav className="login-card-footer-nav">
                      <a href="#!">Terms of use.</a>
                      <a href="#!">Privacy policy</a>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
    </div>
  );
};

export default DemanderIdentifiants;
